<p data-testid="breadcrumbs">
  <ng-container
    *ngFor="let crumb of breadcrumbs | async; let last = last; let i = index"
  >
    <a
      role="link"
      *ngIf="!last"
      [routerLink]="last ? null : crumb.route"
      class="text-capitalize fg-5"
      >{{ crumb.label }}</a
    >
    <span *ngIf="!last" class="text-mono-3"> / </span>
    <span *ngIf="last" class="text-capitalize" data-testid="current">
      {{ crumb.label }}
    </span>
  </ng-container>
</p>
